
import React from 'react';
import { Box, Img, Text } from '@chakra-ui/react';
import { useContext, useEffect, useState, ReactNode } from 'react';
import { ScoreContext, ProfileType } from '../GamePreview';
import { ProfileContext } from '../EntirePreview';
import { motion } from 'framer-motion';
import Scrollbar from 'components/customScroll/CustomScroll';
import { API_SERVER } from 'config/constant';
import { Buttons } from '../../../../components/ui/button';
import { useColor } from '../../../../components/ui/ColorContext';
import { Dialog, DialogContent } from '../../../../components/ui/dialog';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import { updateScreenActivity } from '../common';
// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

type replayScoreProps = {
  getscore:any;
  preloadedAssets: any;
  getData?: any;
  setReplayIsOpen: (value: boolean) => void;
  replayState?: string;
  handleReplayButtonClick?: (replayState: string) => void;
  setCurrentScreenId?: (id: number) => void;
  gameInfo?: any;
  setOptionalReplay?: (value: boolean) => void;
  setQuestState: any;
  setOptions: any;
  setType: any;
  setData: any;
  gameInfoquest: any;
  gameinfodata: any;
  profileData: any;
  replayNextHandler: any;
  data: any;
  feed: string;
  setAudioObj: any;
  isScreenshot: any;
  options: any;
  setSelectedOption: any;
  selectedOption: any;
  questState: any;
  navi: any;
  getSelectedOptions: any;
  isOpen: boolean;
   allQuestScores:any;
   audioCache: any;
  audioReady: boolean;
};

const ReplayScoreFutureTheme: React.FC<replayScoreProps> = ({
  getscore,
  getSelectedOptions,
  getData,
  preloadedAssets,
  setReplayIsOpen,
  replayState,
  handleReplayButtonClick,
  setCurrentScreenId,
  gameInfo,
  setOptionalReplay,
  setQuestState,
  setOptions,
  setType,
  setData,
  gameInfoquest,
  gameinfodata,
  profileData,
  replayNextHandler,
  data,
  feed,
  setAudioObj,
  isScreenshot,
  options,
  setSelectedOption,
  selectedOption,
  questState,
  navi,
  isOpen,
   allQuestScores,
 audioCache,
    audioReady
}) => {
  const { primaryColor } = useColor();
 const { profile, setProfile ,setlearnerActivityrec,deviceInfo} = useContext(ScoreContext);
  const [replayMessage, setReplayMessage] = useState<ReactNode>(null);
  const [translatedContentByLanguage, setTranslatedContentByLanguage] =
    useState(null);

  const playerInfo = useContext(ProfileContext);
  const initialProfileObject: ProfileType = {
    score: [],
    // completionScore: [],
    completedLevels: ['1'],
    compQuest: [],
    currentQuest: 1,
    replayScore: [],
    playerGrandTotal: { questScores: {} },
    playerGender: '',
    PlayerName: '',
    completeBadgseShow: [],
  };
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };

  useEffect(() => {
    const currentQuestMasterData = gameInfo?.gameQuest.find(
      (item: any) => item.gameQuestNo == profile?.currentQuest,
    );
    if (replayState === 'mandatoryReplay') {
      const calculateAttemptScore = (questionList: any[]) => {
        return questionList.reduce((sum, q) => sum + parseInt(q.score || 0), 0);
      };

      const currentQuestIndex = profile?.currentQuest;

      const previousQuestScore =
        profile?.playerGrandTotal.questScores[currentQuestIndex] !== null &&
        Object.entries(profile?.playerGrandTotal?.questScores).length > 0
          ? profile?.playerGrandTotal.questScores[currentQuestIndex]
          : 0;
      const finalPlayerScore = previousQuestScore
        ? parseInt(previousQuestScore)
        : 0;
      const differedScore =
        parseInt(currentQuestMasterData.gameMinScore) - finalPlayerScore;
      setReplayMessage(
        `You are only ${
          differedScore ?? 'few'
        } points away from meeting the passing score. Please try again.`,
      );
    } else if (replayState === 'optionalReplay') {
      const calculateAttemptScore = (questionList: any[]) => {
        return questionList.reduce((sum, q) => sum + parseInt(q.score || 0), 0);
      };
      const questionScoreArray = profile?.score?.filter(
        (item: any) => item.quest === profile?.currentQuest,
      );

      const questionAttempts = profile?.score?.filter(
        (item: any) => item.seqId, // only objects with seqId are real question attempts
      );
     
      const currentQuestIndex = profile?.currentQuest;
      const attemptScore = calculateAttemptScore(questionScoreArray);

   
      profile.score.push({
        quest: currentQuestIndex,
        score: attemptScore,
        attempt:
          profile.score.filter((s: any) => s.quest === currentQuestIndex)
            .length + 1,
        scoreEarnedDate: new Date().toLocaleDateString('en-GB'), // 21-11-2025
      });

    

      const currentQuestMasterData = gameInfo?.gameQuest.find(
        (item: any) => item.gameQuestNo == currentQuestIndex,
      );
    
      const totalScore = currentQuestMasterData?.gameTotalScore
        ? parseInt(currentQuestMasterData.gameTotalScore)
        : 0;

     
      const currentQuest = profile?.currentQuest;

      const attempts = profile?.score?.filter(
        (item: any) => item.quest == currentQuest && item.seqId,
      );

     
      const bestScore = attempts.length
        ? attempts.reduce((sum: any, q: any) => sum + q.score, 0)
        : 0; 
      // Remaining
      let differedScore = totalScore - getscore;
     
      if (differedScore < 0) differedScore = 0;

      // Build message based on BEST score only
      if (differedScore === 0) {
  setReplayMessage(
    <span
      style={{
        color: '#ffffff',
        textShadow: `rgba(${hexToRgb(primaryColor)}, 0.5) 0px 0px 9px`,
        fontFamily: 'Rubik',
        fontSize: '30px',
      }}
    >
      Would you like to replay?
    </span>
  );
} else {
  setReplayMessage(
    <span
      style={{
        color: '#ffffff',
        textShadow: `rgba(${hexToRgb(primaryColor)}, 0.5) 0px 0px 9px`,
        fontFamily: 'Rubik',
        fontSize: '20px',
      }}
    >
      You are only {differedScore} points away from a perfect score. Would you like to replay?
    </span>
  );
}

    }
  }, [replayState]);

  useEffect(() => {
    if (selectedOption !== '' && replayState === 'replayPointPrompt') {
     

      feedBackAudioPlay();
    }
  }, [selectedOption, replayState]);
  const playClickSound = () => {
        try {
          const audio = new Audio(BtnClickSound as string);
          audio.volume = 1;
          audio.play().catch(() => { });
  
          setTimeout(() => {
            audio.pause();
            audio.currentTime = 0;
          }, 1000);
        } catch (e) {
          // ignore audio errors
        }
      };
      
  const getCachedAudio = (path: any) => {
    if (!path) return null;
    const cachedUrl = audioCache[path];
    if (!cachedUrl) {
      console.warn("Audio not preloaded:", path);
      return null;
    }
    return cachedUrl;
  };
  const feedBackAudioPlay = async () => {
   

    if (selectedOption !== '' && profileData?.Audiogetlanguage.length === 0) {
    

      // Ensure getSelectedOptions is an object, not an array
      if (getSelectedOptions && getSelectedOptions.options) {
        const foundOptionSelected = getSelectedOptions.options;
        const AccessFindUrl = options?.filter(
          (item: any) => foundOptionSelected === item?.qpOptions,
        );
        const FindUrl = AccessFindUrl[0]?.qbfeedbackAudioUrl;


        if (FindUrl?.length > 0) {
          try {
            const optionFeedBackAudio = FindUrl ? FindUrl : '';
   if (optionFeedBackAudio !== '') {
              // const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
              // const responseblockText = await fetch(fullUrl);
              const fullUrl = getCachedAudio(optionFeedBackAudio);
              if (fullUrl) {
                setAudioObj((prev: any) => ({
                  ...prev,
                  url: fullUrl.src,
                  type: EnumType.VOICE,
                  loop: false,
                  autoplay: true,
                }));
              }
            }
           
            // if (optionFeedBackAudio !== '') {
            //   const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
            //   const responseblockText = await fetch(fullUrl);

            //   if (responseblockText.ok) {
            //     setAudioObj((prev: any) => ({
            //       ...prev,
            //       url: fullUrl,
            //       type: EnumType.VOICE,
            //       loop: false,
            //       autoplay: true,
            //     }));
            //   }
            // }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      } else {
        console.error(
          'getSelectedOptions is missing options property:',
          getSelectedOptions,
        );
      }
    }
  };

  return (
    <>
      <Box id="container" className="Play-station">
        <Box className="top-menu-home-section">
          <Box className="Setting-box">
            <motion.div
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20,
              }}
              style={{
                width: '100%',
                height: '100%',
                // backgroundColor: 'coral',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {[
                'replayPointPrompt',
                'optionalReplay',
                'mandatoryReplay',
              ].includes(replayState) ? (
                <>
                 
                  <Box
                    className={
                      replayState === 'Prompt'
                        ? 'replay-prompt-vertex'
                        : 'replay-vertex replayPointPrompt repaly-height'
                    }
                    style={{height:"none !important"}}
                  >
                    
                    {replayState === 'replayPointPrompt' && (
  <>
  <div className="relative w-full max-h-[450px] rounded-3xl p-6 backdrop-blur-[2.5rem] flex flex-col overflow-hidden">

  {/* Main Content Wrapper */}
  <div className="relative flex flex-1 flex-col gap-6 overflow-hidden">

    {/* ================= HEADER (FIXED) ================= */}
    <div className="shrink-0 flex flex-col gap-6">

      {/* Title */}
      <div
        className="text-center text-4xl font-normal tracking-[0.005rem]"
        style={{
          color: primaryColor,
          textShadow: `rgba(${hexToRgb(primaryColor)},0.5) 0px 0px 9px`,
        }}
      >
        <p>Replay Point</p>
      </div>

      {/* Decorative Line */}
      <div className="relative flex h-[1px] w-full items-center justify-center">
        <div className="w-full rotate-[179.99deg] scale-y-[-1]">
          <svg
            className="block h-[1px] w-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 525 1"
          >
            <line
              stroke={`url(#paint0_linear_replay_${primaryColor.replace(
                '#',
                '',
              )})`}
              strokeWidth="0.894962"
              x2="524.592"
              y1="0.552519"
              y2="0.552519"
            />
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id={`paint0_linear_replay_${primaryColor.replace('#', '')}`}
                x1="524.592"
                x2="0"
                y1="0.999899"
                y2="0.999919"
              >
                <stop stopColor={primaryColor} stopOpacity="0" />
                <stop
                  offset="0.484375"
                  stopColor={primaryColor}
                  stopOpacity="0.994792"
                />
                <stop stopColor={primaryColor} stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

    </div>

    {/* ================= SCROLLABLE CONTENT ================= */}
    <div className="flex-1 overflow-y-auto pr-2">
      <div className="font-rubik text-center z-10 text-[1.188rem] font-normal leading-[2.125rem] -tracking-[0.005rem] text-white">
        {feed ||
          `You have been redirected to the replay point. Click "Replay" to continue`}
      </div>
    </div>

    {/* ================= FOOTER (FIXED) ================= */}
    <div className="shrink-0 relative z-10 flex w-full items-center justify-center mt-6">
      <Buttons
        onClick={() => {
          playClickSound();
          setReplayIsOpen(false);
          handleReplayButtonClick(replayState);
        }}
        variant="ghost"
        size="sm"
        className="font-rubik h-12 w-full max-w-32 rounded-[2.5rem] px-4 py-2 text-lg font-medium tracking-[0.034rem] text-white transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(100deg, rgba(${hexToRgb(
            primaryColor,
          )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
          border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
          boxShadow: `0px 0px 21.786px rgba(${hexToRgb(
            primaryColor,
          )}, 0.4)`,
        }}
      >
        Replay
      </Buttons>
    </div>

  </div>

  {/* ================= BACKGROUND EFFECT ================= */}
  <div className="absolute left-[21.611rem] h-[24.843rem] w-[27.362rem] mix-blend-lighten pointer-events-none">

    <div className="absolute inset-[-102%]">
      <svg className="block size-full" fill="none" viewBox="0 0 1250 1210">
        <g
          filter={`url(#filter0_f_replay_${primaryColor.replace('#', '')})`}
          opacity="0.2"
          className="mix-blend-lighten"
        >
          <ellipse
            cx="624.898"
            cy="604.747"
            rx="218.898"
            ry="198.747"
            fill={primaryColor}
          />
        </g>
      </svg>
    </div>

    <div className="absolute inset-[-200%]">
      <svg className="block size-full" fill="none" viewBox="0 0 1250 1210">
        <g
          filter={`url(#filter0_f_replay_${primaryColor.replace('#', '')})`}
          opacity="0.1"
          className="mix-blend-lighten"
        >
          <ellipse
            cx="624.898"
            cy="604.747"
            rx="218.898"
            ry="198.747"
            fill={primaryColor}
          />
        </g>
      </svg>
    </div>

  </div>

  {/* ================= CARD BORDERS ================= */}
  <div className="pointer-events-none absolute inset-0 shadow-[1.58049px_3.16098px_12.6439px_0px_inset_rgba(248,248,248,0.06)]" />

  <div
    className="pointer-events-none absolute inset-0 rounded-3xl border"
    style={{
      border: `1.18537px solid ${primaryColor}33`,
      boxShadow: `0px 3.16098px 3.16098px rgba(${hexToRgb(
        primaryColor,
      )}, 0.12)`,
    }}
  />

</div>



  </>
)}


                      {replayState === 'optionalReplay' && (
                        <>
                          {/* <Dialog>
                            <DialogContent
                              className="border-none bg-transparent p-0 shadow-none sm:max-w-[35.75rem]"
                            > */}
                          <div className="relative w-full overflow-hidden rounded-3xl p-6 backdrop-blur-[2.5rem] backdrop-filter">
                            <div className="relative box-border flex h-full shrink-0 grow basis-0 flex-col content-stretch items-center  justify-end gap-8 p-0">
                              {/* Main Content */}
                              <div className="flex w-full flex-col gap-6">
                                {/* Title Section */}
                                <div
                                  className="font-rubik flex h-44 items-center justify-center text-center text-3xl font-normal tracking-tight"
                                  style={{
                                    color: '#ffffff',
                                    textShadow: `rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.5) 0px 0px 9px`,
                                  }}
                                >
                                  <p className="mt-5">
                                    {replayMessage}
                                    {/* Would you like to replay ? */}
                                  </p>
                                </div>
                              </div>

                              {/* Replay Button & Next Button */}
                              <div className=" relative z-10 flex w-full shrink-0 items-center justify-center gap-8">
                                <Buttons
                                  // onClick={handleReplay}
                                  onClick={() => {
                                    playClickSound();
                                    setReplayIsOpen(false);
                                    handleReplayButtonClick(replayState);
                                      setlearnerActivityrec((prev: any) =>
                                        updateScreenActivity(
                                          prev,
                                          99,
                                          "Replay Prompt",
                                          deviceInfo,
                                          {
                                            replyPromptopen:true,
                                            replyPromptclose:true,
                                            promptscenario : 'optionalReplay',
                                            replayplayaction : true
                                          }
                                        )
                                    );
                                  }}
                                  variant="ghost"
                                  size="sm"
                                  className="font-rubik h-12 w-full max-w-32 rounded-3xl px-4 py-2 text-lg font-medium tracking-tight text-white transition-all duration-200 hover:scale-110 hover:text-white"
                                  style={{
                                    background: `linear-gradient(100deg ,
                        rgba(${hexToRgb(
                          primaryColor,
                        )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                                    border: `1px solid rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.5)`,
                                    boxShadow: `0px 0px 21.786px 0px rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.4)`,
                                  }}
                                >
                                  Replay
                                </Buttons>

                                <Buttons
                                  // onClick={handleNextClick}
                                  onClick={() => {
                                     playClickSound();
                                    setReplayIsOpen(false);
                                    replayNextHandler(data);
                                    setlearnerActivityrec((prev: any) =>
                                        updateScreenActivity(
                                          prev,
                                          99,
                                          "Replay Prompt",
                                          deviceInfo,
                                          {
                                            replyPromptopen:true,
                                            replyPromptclose:true,
                                            promptscenario : 'optionalReplay',
                                            replayplayaction : false,
                                          }
                                        )
                                    );
                                  }}
                                  variant="ghost"
                                  size="sm"
                                  className="font-rubik h-12 w-full max-w-32 rounded-3xl px-4 py-2 text-lg font-medium tracking-tight text-white transition-all duration-200 hover:scale-110 hover:text-white"
                                  style={{
                                    background: `linear-gradient(100deg ,
                        rgba(${hexToRgb(
                          primaryColor,
                        )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                                    border: `1px solid rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.5)`,
                                    boxShadow: `0px 0px 21.786px 0px rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.4)`,
                                  }}
                                >
                                  Next
                                </Buttons>
                              </div>

                              {/* Background Ellipse */}
                              <div className="absolute left-[21.611rem] h-[24.843rem] w-[27.362rem] mix-blend-lighten">
                                <div className="absolute bottom-[-102.084%] left-[-92.686%] right-[-92.686%] top-[-102.084%]">
                                  <svg
                                    className="block h-full w-full"
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 1250 1210"
                                  >
                                    <g
                                      filter={`url(#filter0_f_replay_${primaryColor.replace(
                                        '#',
                                        '',
                                      )})`}
                                      id="Ellipse 7187"
                                      opacity="0.2"
                                      style={{ mixBlendMode: 'lighten' }}
                                    >
                                      <ellipse
                                        cx="624.898"
                                        cy="604.747"
                                        fill={primaryColor}
                                        rx="218.898"
                                        ry="198.747"
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        colorInterpolationFilters="sRGB"
                                        filterUnits="userSpaceOnUse"
                                        height="1209.05"
                                        id={`filter0_f_replay_${primaryColor.replace(
                                          '#',
                                          '',
                                        )}`}
                                        width="1249.35"
                                        x="0.223328"
                                        y="0.223328"
                                      >
                                        <feFlood
                                          floodOpacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feBlend
                                          in="SourceGraphic"
                                          in2="BackgroundImageFix"
                                          mode="normal"
                                          result="shape"
                                        />
                                        <feGaussianBlur
                                          result="effect1_foregroundBlur_49_33"
                                          stdDeviation="202.888"
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="absolute bottom-[-200.084%] left-[-200.686%] right-[-110.686%] top-[-100.084%]">
                                  <svg
                                    className="block h-full w-full"
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 1250 1210"
                                  >
                                    <g
                                      filter={`url(#filter0_f_replay_${primaryColor.replace(
                                        '#',
                                        '',
                                      )})`}
                                      id="Ellipse 7187"
                                      opacity="0.1"
                                      style={{ mixBlendMode: 'lighten' }}
                                    >
                                      <ellipse
                                        cx="624.898"
                                        cy="604.747"
                                        fill={primaryColor}
                                        rx="218.898"
                                        ry="198.747"
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        colorInterpolationFilters="sRGB"
                                        filterUnits="userSpaceOnUse"
                                        height="1209.05"
                                        id={`filter0_f_replay_${primaryColor.replace(
                                          '#',
                                          '',
                                        )}`}
                                        width="1249.35"
                                        x="0.223328"
                                        y="0.223328"
                                      >
                                        <feFlood
                                          floodOpacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feBlend
                                          in="SourceGraphic"
                                          in2="BackgroundImageFix"
                                          mode="normal"
                                          result="shape"
                                        />
                                        <feGaussianBlur
                                          result="effect1_foregroundBlur_49_33"
                                          stdDeviation="202.888"
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            {/* Card Borders and Effects */}
                            <div className="pointer-events-none absolute inset-0 shadow-[1.58049px_3.16098px_12.6439px_0px_inset_rgba(248,248,248,0.06)]" />
                            <div
                              className="pointer-events-none absolute inset-0 rounded-3xl border-solid"
                              style={{
                                border: `1.18537px solid ${primaryColor}33`,
                                boxShadow: `0px 3.16098px 3.16098px 0px rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.12)`,
                              }}
                            />
                          </div>
                          {/* </DialogContent>
                          </Dialog> */}
                        </>
                      )}
                     {replayState === 'mandatoryReplay' && (
                        <>
                            <div className="relative w-full overflow-hidden rounded-3xl p-6 backdrop-blur-[2.5rem] backdrop-filter">
                            <div className="relative box-border flex h-full shrink-0 grow basis-0 flex-col content-stretch items-center  justify-end gap-8 p-0">
                              {/* Main Content */}
                              <div className="flex w-full flex-col gap-6">
                                {/* Title Section */}
                                <div
                                  className="font-rubik flex h-44 items-center justify-center text-center text-3xl font-normal tracking-tight"
                                  style={{
                                    color: '#ffffff',
                                    textShadow: `rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.5) 0px 0px 9px`,
                                  }}
                                >
                                  <p className="mt-5">
                                    {replayMessage}
                                  </p>
                                </div>
                              </div>

                              {/* Replay Button  */}
                              <div className=" relative z-10 flex w-full shrink-0 items-center justify-center gap-8">
                                <Buttons
                                  onClick={() => {
                                    playClickSound();
                                    setReplayIsOpen(false);
                                    handleReplayButtonClick(replayState);
                                     setlearnerActivityrec((prev: any) =>
                                      updateScreenActivity(
                                        prev,
                                        99,
                                        "Replay Prompt",
                                        deviceInfo,
                                        {
                                          replyPromptopen:true,
                                          replyPromptclose:true,
                                          promptscenario : 'mandatoryReplay',
                                          replayplayaction : true
                                        }
                                      )
                                    );
                                  }}
                                  variant="ghost"
                                  size="sm"
                                  className="font-rubik h-12 w-full max-w-32 rounded-3xl px-4 py-2 text-lg font-medium tracking-tight text-white transition-all duration-200 hover:scale-110 hover:text-white"
                                  style={{
                                    background: `linear-gradient(100deg ,
                        rgba(${hexToRgb(
                          primaryColor,
                        )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                                    border: `1px solid rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.5)`,
                                    boxShadow: `0px 0px 21.786px 0px rgba(${hexToRgb(
                                      primaryColor,
                                    )}, 0.4)`,
                                  }}
                                >
                                  Replay
                                </Buttons>

                              
                              </div>

                              {/* Background Ellipse */}
                              <div className="absolute left-[21.611rem] h-[24.843rem] w-[27.362rem] mix-blend-lighten">
                                <div className="absolute bottom-[-102.084%] left-[-92.686%] right-[-92.686%] top-[-102.084%]">
                                  <svg
                                    className="block h-full w-full"
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 1250 1210"
                                  >
                                    <g
                                      filter={`url(#filter0_f_replay_${primaryColor.replace(
                                        '#',
                                        '',
                                      )})`}
                                      id="Ellipse 7187"
                                      opacity="0.2"
                                      style={{ mixBlendMode: 'lighten' }}
                                    >
                                      <ellipse
                                        cx="624.898"
                                        cy="604.747"
                                        fill={primaryColor}
                                        rx="218.898"
                                        ry="198.747"
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        colorInterpolationFilters="sRGB"
                                        filterUnits="userSpaceOnUse"
                                        height="1209.05"
                                        id={`filter0_f_replay_${primaryColor.replace(
                                          '#',
                                          '',
                                        )}`}
                                        width="1249.35"
                                        x="0.223328"
                                        y="0.223328"
                                      >
                                        <feFlood
                                          floodOpacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feBlend
                                          in="SourceGraphic"
                                          in2="BackgroundImageFix"
                                          mode="normal"
                                          result="shape"
                                        />
                                        <feGaussianBlur
                                          result="effect1_foregroundBlur_49_33"
                                          stdDeviation="202.888"
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="absolute bottom-[-200.084%] left-[-200.686%] right-[-110.686%] top-[-100.084%]">
                                  <svg
                                    className="block h-full w-full"
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 1250 1210"
                                  >
                                    <g
                                      filter={`url(#filter0_f_replay_${primaryColor.replace(
                                        '#',
                                        '',
                                      )})`}
                                      id="Ellipse 7187"
                                      opacity="0.1"
                                      style={{ mixBlendMode: 'lighten' }}
                                    >
                                      <ellipse
                                        cx="624.898"
                                        cy="604.747"
                                        fill={primaryColor}
                                        rx="218.898"
                                        ry="198.747"
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        colorInterpolationFilters="sRGB"
                                        filterUnits="userSpaceOnUse"
                                        height="1209.05"
                                        id={`filter0_f_replay_${primaryColor.replace(
                                          '#',
                                          '',
                                        )}`}
                                        width="1249.35"
                                        x="0.223328"
                                        y="0.223328"
                                      >
                                        <feFlood
                                          floodOpacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feBlend
                                          in="SourceGraphic"
                                          in2="BackgroundImageFix"
                                          mode="normal"
                                          result="shape"
                                        />
                                        <feGaussianBlur
                                          result="effect1_foregroundBlur_49_33"
                                          stdDeviation="202.888"
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            {/* Card Borders and Effects */}
                            <div className="pointer-events-none absolute inset-0 shadow-[1.58049px_3.16098px_12.6439px_0px_inset_rgba(248,248,248,0.06)]" />
                            <div
                              className="pointer-events-none absolute inset-0 rounded-3xl border-solid"
                              style={{
                                border: `1.18537px solid ${primaryColor}33`,
                                boxShadow: `0px 3.16098px 3.16098px 0px rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.12)`,
                              }}
                            />
                          </div>
                        
                        </>
                      )}
                  </Box>
                </>
              ) : (
                <>
                  {/** ReplayGame prompt*/}
                  <Img
                    src={preloadedAssets?.overview}
                    className="setting-pad"
                  />
                  <Dialog>
                    <DialogContent
                      className="border-none bg-transparent p-0 shadow-none sm:max-w-[35.75rem]"
                      showCloseButton={false}
                    >
                      <div className="relative w-full overflow-hidden rounded-3xl p-6 backdrop-blur-[2.5rem] backdrop-filter">
                        <div className="relative box-border flex h-full shrink-0 grow basis-0 flex-col content-stretch items-center  justify-end gap-8 p-0">
                          {/* Main Content */}
                          <div className="flex w-full flex-col gap-6">
                            {/* Title Section */}
                            <div
                              className="font-rubik flex h-44 items-center justify-center text-center text-3xl font-normal tracking-tight"
                              style={{
                                color: '#ffffff',
                                textShadow: `rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.5) 0px 0px 9px`,
                              }}
                            >
                              <p className="mt-5">Would you like to replay ?</p>
                            </div>
                          </div>

                          {/* Replay Button & Next Button */}
                          <div className="relative z-10 flex w-full shrink-0 items-center justify-center gap-8">
                            <Buttons
                              onClick={() => {
                                setReplayIsOpen(false);
                              }}
                              variant="ghost"
                              size="sm"
                              className="font-rubik h-12 w-full max-w-32 rounded-3xl px-4 py-2 text-lg font-medium tracking-tight text-white transition-all duration-200 hover:scale-110 hover:text-white"
                              style={{
                                background: `linear-gradient(100deg ,
                        rgba(${hexToRgb(
                          primaryColor,
                        )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                                border: `1px solid rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.5)`,
                                boxShadow: `0px 0px 21.786px 0px rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.4)`,
                              }}
                            >
                              Replay
                            </Buttons>

                            <Buttons
                              onClick={() => {
                                 playClickSound();
                                replayNextHandler(data);
                              }}
                              variant="ghost"
                              size="sm"
                              className="font-rubik h-12 w-full max-w-32 rounded-3xl px-4 py-2 text-lg font-medium tracking-tight text-white transition-all duration-200 hover:scale-110 hover:text-white"
                              style={{
                                background: `linear-gradient(100deg ,
                        rgba(${hexToRgb(
                          primaryColor,
                        )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                                border: `1px solid rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.5)`,
                                boxShadow: `0px 0px 21.786px 0px rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.4)`,
                              }}
                            >
                              Nextdedault
                            </Buttons>
                          </div>

                          {/* Background Ellipse */}
                          <div className="absolute left-[21.611rem] h-[24.843rem] w-[27.362rem] mix-blend-lighten">
                            <div className="absolute bottom-[-102.084%] left-[-92.686%] right-[-92.686%] top-[-102.084%]">
                              <svg
                                className="block h-full w-full"
                                fill="none"
                                preserveAspectRatio="none"
                                viewBox="0 0 1250 1210"
                              >
                                <g
                                  filter={`url(#filter0_f_replay_${primaryColor.replace(
                                    '#',
                                    '',
                                  )})`}
                                  id="Ellipse 7187"
                                  opacity="0.2"
                                  style={{ mixBlendMode: 'lighten' }}
                                >
                                  <ellipse
                                    cx="624.898"
                                    cy="604.747"
                                    fill={primaryColor}
                                    rx="218.898"
                                    ry="198.747"
                                  />
                                </g>
                                <defs>
                                  <filter
                                    colorInterpolationFilters="sRGB"
                                    filterUnits="userSpaceOnUse"
                                    height="1209.05"
                                    id={`filter0_f_replay_${primaryColor.replace(
                                      '#',
                                      '',
                                    )}`}
                                    width="1249.35"
                                    x="0.223328"
                                    y="0.223328"
                                  >
                                    <feFlood
                                      floodOpacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feBlend
                                      in="SourceGraphic"
                                      in2="BackgroundImageFix"
                                      mode="normal"
                                      result="shape"
                                    />
                                    <feGaussianBlur
                                      result="effect1_foregroundBlur_49_33"
                                      stdDeviation="202.888"
                                    />
                                  </filter>
                                </defs>
                              </svg>
                            </div>
                            <div className="absolute bottom-[-200.084%] left-[-200.686%] right-[-110.686%] top-[-100.084%]">
                              <svg
                                className="block h-full w-full"
                                fill="none"
                                preserveAspectRatio="none"
                                viewBox="0 0 1250 1210"
                              >
                                <g
                                  filter={`url(#filter0_f_replay_${primaryColor.replace(
                                    '#',
                                    '',
                                  )})`}
                                  id="Ellipse 7187"
                                  opacity="0.1"
                                  style={{ mixBlendMode: 'lighten' }}
                                >
                                  <ellipse
                                    cx="624.898"
                                    cy="604.747"
                                    fill={primaryColor}
                                    rx="218.898"
                                    ry="198.747"
                                  />
                                </g>
                                <defs>
                                  <filter
                                    colorInterpolationFilters="sRGB"
                                    filterUnits="userSpaceOnUse"
                                    height="1209.05"
                                    id={`filter0_f_replay_${primaryColor.replace(
                                      '#',
                                      '',
                                    )}`}
                                    width="1249.35"
                                    x="0.223328"
                                    y="0.223328"
                                  >
                                    <feFlood
                                      floodOpacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feBlend
                                      in="SourceGraphic"
                                      in2="BackgroundImageFix"
                                      mode="normal"
                                      result="shape"
                                    />
                                    <feGaussianBlur
                                      result="effect1_foregroundBlur_49_33"
                                      stdDeviation="202.888"
                                    />
                                  </filter>
                                </defs>
                              </svg>
                            </div>
                          </div>
                        </div>

                        {/* Card Borders and Effects */}
                        <div className="pointer-events-none absolute inset-0 shadow-[1.58049px_3.16098px_12.6439px_0px_inset_rgba(248,248,248,0.06)]" />
                        <div
                          className="pointer-events-none absolute inset-0 rounded-3xl border-solid"
                          style={{
                            border: `1.18537px solid ${primaryColor}33`,
                            boxShadow: `0px 3.16098px 3.16098px 0px rgba(${hexToRgb(
                              primaryColor,
                            )}, 0.12)`,
                          }}
                        />
                      </div>
                    </DialogContent>
                  </Dialog>
                 
                </>
              )}
            </motion.div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ReplayScoreFutureTheme;
